module.exports = __webpack_public_path__ + "static/media/edit.161f9c86.svg";